import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Button, StandardDialog } from '@roc/ui';
import { Grid, Step, StepContent, StepLabel, Stepper } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SearchBorrowersForPricingEconomicsTier } from './searchBorrowersForPricingEconomicsTier';
import { CompanyProfileStore } from '../../stores/companyProfileStore';
import PricingEconomicsDefaultFees from './pricingEconomicsDefaultFees';
import { TitleDivider } from 'libs/feature-one-tool/src/quote/components/titleDivider';
import { TitleDividerWithButton } from 'libs/client-portal-shared/src/app/components/titleDivider/titleDividerWithButton';

export type AddPricingEconomicsTierProps = {
  companyProfileStore: CompanyProfileStore
  stepsLabel: any[]
  stepsContent: any[]
  skipStepValidation?: boolean
  onSave: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    stepsContentContainer: {
      margin: theme.spacing(4),
    },
    button: {
      width: '300px'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    alertWrapper: {
      width: '100%',
      marginBottom: '16px'
    },
    stepper: {
      width: '100%'
    }
  })
);

export const PricingEconomicsStepper = observer((props: AddPricingEconomicsTierProps) => {
  const { companyProfileStore, stepsLabel, stepsContent, onSave, skipStepValidation = false } = props
  const { lenderTermTierEconomicsFormStore } = companyProfileStore
  const [activeStep, setActiveStep] = useState(0);
  const classes = useStyles();

  const getStepContent = (step: number) => {
    return stepsContent[step]
  }

  const handleNext = () => {
    if (skipStepValidation || stepsLabel[activeStep] === 'Select Borrower(s) for Economics') {
      setActiveStep(prev => prev + 1)
    } else {
      if (lenderTermTierEconomicsFormStore.validateTermTierByStep(activeStep)) {
        setActiveStep(prev => prev + 1)
      }
    }
  }

  const goToIndex = (index) => {
    setActiveStep(index)
  }

  return (
    <Grid container style={{ marginTop: '-24px' }}>
      <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepper}>
        {stepsLabel.map((label, index) => (
          <Step key={label}>
            <StepLabel>
              <TitleDividerWithButton
                onClick={() => goToIndex(index)}
                title={label}
                showButton={index < activeStep} />
            </StepLabel>
            <StepContent TransitionProps={{ unmountOnExit: false }} >
              <Grid xs={12} className={classes.stepsContentContainer}>
                {getStepContent(index)}
              </Grid>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Grid container justifyContent={'center'} spacing={2}>
        <Grid item xs={12} className={classes.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={activeStep === stepsLabel.length - 1 ? onSave : handleNext}
            testId={`save-${activeStep + 1}`}
            className={classes.button}
          >
            {activeStep === stepsLabel.length - 1 ? 'SAVE' : 'NEXT'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default PricingEconomicsStepper;
